<template>
 
<div class="center">

        <br><br><br>

        <Card style="width: 25em">
            <template #header>
                <img src="login.png" style="height: 10rem" />
            </template>
            <template #title>
                LOKII-CE Platform Login 
            </template>
            <template #subtitle>
                ( Development version )
            </template>
            <template #content>
                <p>  <InputText placeholder="Email" v-model="email"   /></p>
                <p>  <Password placeholder="Password" v-model="password" /></p>
                <p v-if="errMsg">{{ errMsg }}</p>
            </template>
            <template #footer>
                <p><Button @click="signIn"   >Submit</Button></p>
            </template>
        </Card>

  
</div>


</template>



<style>
.center {
  margin-left: auto;
  margin-right: auto;
  margin-top: auto;
  width: 50%;

}
</style>



<script setup>

 


  import { ref } from 'vue'


  // Edward: import directly from firebase web version 8
  import firebase from  "../firebaseInit"

  import { useRouter } from 'vue-router' // import router
  const email = ref('')
  const password = ref('')
  const errMsg = ref() // ERROR MESSAGE
  const router = useRouter() // get a reference to our vue router
  const signIn = () => { // we also renamed this method
    
      firebase.auth()
      .signInWithEmailAndPassword(email.value, password.value) // THIS LINE CHANGED
      .then((userCredential) => {
        console.log('Successfully logged in!', userCredential.user );

        router.push('/home') // redirect to the feed: dashboard
      })
      .catch(error => {
        switch (error.code) {

        /*
          case 'auth/invalid-email':
              errMsg.value = 'Invalid email'
              break
          case 'auth/user-not-found':
              errMsg.value = 'No account with that email was found'
              break
          case 'auth/wrong-password':
              errMsg.value = 'Incorrect password'
              break
          default:
              errMsg.value = 'Email or password was incorrect'
              break
              */
           default:
                errMsg.value = 'Incorrect password'
                break;
        }
        // console.log(errMsg.value);

       // ref.swal( errMsg.value);
      });
  }
</script>
